import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

gsap.registerPlugin(ScrollTrigger);

export default function Comp() {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationH .msg-box1',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: '.animationH .msg-box2',
            offset: 50, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '10%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationH .msg-box1',
            0.5,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        const tweenA2 = TweenMax.fromTo(
            '.animationH .msg-box2',
            0.2,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );

        sceneA1.setTween(tweenA1);
        sceneA2.setTween(tweenA2);
        /* @ts-ignore */
        controllerDelta2?.addScene(sceneA1);
        /* @ts-ignore */
        controllerDelta2?.addScene(sceneA2);
    }, []);

    const linkMap: any = {
        cn: '/collections/solar-panels',
        kr: 'https://kr.ecoflow.com/pages/solar-panel',
        us: `https://${locale}.ecoflow.com/collections/delta-2-solar-generators`,
        tw: '/collections/solar-panels',
        br: 'https://br.ecoflow.com/products/delta-2-220w-portable-solar-panel',
        mx: 'https://mx.ecoflow.com/products/delta-2-220w-portable-solar-panel',
        ph: 'https://ph.ecoflow.com/products/ecoflow-delta-2-220w-solar-panel',
    };

    return (
        <div className={`${css.animationH} animationH GtmModuleData-section`} data-section-id={css.animationH} data-section-title={t('delta2.aniH_msg1')}>
            <div className="static-box">
                <div className="msg-box1">
                    <div className="msg-title1 title-bolder">{t('delta2.aniH_msg1')}</div>
                    <div className="msg-title2">
                        <div className="msg-desc1">
                            <span>{t('delta2.aniH_msg2')}</span>
                            <span>{t('delta2.aniH_msg2_highlight')}</span>
                        </div>
                    </div>
                </div>
                <div className="img-box">
                    <EFPic name={['animH.webp', 'animH.jpg']} alt={t('delta2.aniH_msg5')} />
                </div>
                <div className="msg-box2">
                    <div className="msg-desc">{t('delta2.aniH_msg5')}</div>
                    {!['jp', 'cis', 'za', 'sa'].includes(locale) && (
                        <div className="go-solar">
                            <Link href={linkMap[locale] || linkMap.us}>{t('delta2.aniH_msg6')}</Link>
                            <EFAppArrow height="14px" width="14px" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
